import { render, staticRenderFns } from "./TickCrossDate.vue?vue&type=template&id=06c29f20&scoped=true&"
import script from "./TickCrossDate.vue?vue&type=script&lang=ts&"
export * from "./TickCrossDate.vue?vue&type=script&lang=ts&"
import style0 from "./TickCrossDate.vue?vue&type=style&index=0&id=06c29f20&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c29f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c29f20')) {
      api.createRecord('06c29f20', component.options)
    } else {
      api.reload('06c29f20', component.options)
    }
    module.hot.accept("./TickCrossDate.vue?vue&type=template&id=06c29f20&scoped=true&", function () {
      api.rerender('06c29f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/TickCrossDate.vue"
export default component.exports